module.exports = __webpack_public_path__ + "static/media/81OLHPnUi3L._AC_SL1500_.d1e28439.jpg";